<template>
  <el-select v-model="localModel" :multiple="multiple" v-bind="$attrs">
    <el-option
      v-for="item in items"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: 'BaseSelect',
  props: {
    items: { type: Array, default: () => [] },
    value: { type: [Array, String, Number], default: ''},
    multiple: { type: Boolean, default: false }
  },
  model: {
    prop: 'value',
    event: 'update:value'
  },
  computed: {
    localModel: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('update:value', v)
      }
    }
  }
}
</script>

<style>

</style>
